// Dependencies
import React, { Component } from 'react';
import CvDataComponent from './cv-data/cv-data';
import OtherTrainingDataComponent from './other-training-data/other-training-data';
import BaseQualificationDataComponent from './base-qualification-data/base-qualification-data';
import PhysioPostGradDataComponent from './physio-pos-grad-data/physio-post-grad-data';
import OtherPostGradDataComponent from './other-post-grad-data/other-post-grad-data';

// Primereact imports
import { TabMenu } from 'primereact/tabmenu';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';

// Styling
import './qualification-data.scss';
import { isMobileOnly } from 'react-device-detect';

class QualificationDataComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
        tabIndex: 0,
        tabMenuItems: [
            { label: this.props.t("profile.areas.qualification.areas.base-data.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 0}) },
            { label: isMobileOnly ? this.props.t("profile.areas.qualification.areas.physio-post-grad.title-mobile") : this.props.t("profile.areas.qualification.areas.physio-post-grad.title"), disabled: this.props.editMode, command: () => { this.setState({tabIndex: 1})} },
            { label: this.props.t("profile.areas.qualification.areas.other-post-grad.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 2}) },
            { label: isMobileOnly ? this.props.t("profile.areas.qualification.areas.other.title-mobile") : this.props.t("profile.areas.qualification.areas.other.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 3}) },
            { label: isMobileOnly ? this.props.t("profile.areas.qualification.areas.cv.title-mobile") : this.props.t("profile.areas.qualification.areas.cv.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 4}) }
        ]
    };
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.language !== prevProps.language) {
        this.setState({
          tabMenuItems: [
              { label: this.props.t("profile.areas.qualification.areas.base-data.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 0}) },
              { label: isMobileOnly ? this.props.t("profile.areas.qualification.areas.physio-post-grad.title-mobile") : this.props.t("profile.areas.qualification.areas.physio-post-grad.title"), disabled: this.props.editMode, command: () => { this.setState({tabIndex: 1})} },
              { label: this.props.t("profile.areas.qualification.areas.other-post-grad.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 2}) },
              { label: isMobileOnly ? this.props.t("profile.areas.qualification.areas.other.title-mobile") : this.props.t("profile.areas.qualification.areas.other.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 3}) },
              { label: isMobileOnly ? this.props.t("profile.areas.qualification.areas.cv.title-mobile") : this.props.t("profile.areas.qualification.areas.cv.title"), disabled: this.props.editMode, command: () => this.setState({tabIndex: 4}) }
          ]
        });
    }
  }

  render() {

    return (
      <div className="grid mgb-80">
          <div className='col-12'>
              <TabMenu model={this.state.tabMenuItems} activeIndex={this.state.tabIndex} onTabChange={(e) => this.setState({tabIndex: e.index})} />
              { this.state.tabIndex === 0 ? <BaseQualificationDataComponent /> : null }
              { this.state.tabIndex === 1 ? <PhysioPostGradDataComponent /> : null }
              { this.state.tabIndex === 2 ? <OtherPostGradDataComponent /> : null }
              { this.state.tabIndex === 3 ? <OtherTrainingDataComponent /> : null }
              { this.state.tabIndex === 4 ? <CvDataComponent /> : null }
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      editMode: state.profile.editMode,
      language: state.profile.language
  } 
};

export default connect(mapStateToProps, undefined)(withTranslation(QualificationDataComponent));